export function buildAnalyticsSearchParams(filters = {}) {
  const params = new URLSearchParams();

  if (filters.from_date) params.set("from_date", filters.from_date);
  if (filters.to_date) params.set("to_date", filters.to_date);

  params.set("group_by", filters.group_by || "day");

  if (filters.shop_ranking) {
    params.set("shop_ranking", filters.shop_ranking);
  }

  if (filters.ranking_currency) {
    params.set("ranking_currency", filters.ranking_currency);
  }

  (Array.isArray(filters.shop_ids) ? filters.shop_ids : [])
    .filter(Boolean)
    .forEach((shopId) => params.append("shop_ids[]", shopId));

  (Array.isArray(filters.currencies) ? filters.currencies : [])
    .filter(Boolean)
    .forEach((currency) => params.append("currencies[]", currency));

  return params;
}
